import { useMutation } from "@tanstack/react-query"

import { login, type LoginRequest, type TokenPair } from "@/features/auth/api/auth.api"
import { useAuth } from "@/features/auth/hooks/use-auth"

export function useLogin() {
  const { setSession } = useAuth()

  return useMutation<TokenPair, Error, LoginRequest>({
    mutationFn: login,
    onSuccess: (tokens) => {
      setSession(tokens)
    },
  })
}
